const msg = {
  APP_NAME: "Ballog",
  COPYRIGHT: "Ballog AB © 2020",

  FORM_VALIDATION_REQUIRED: "Required",
  FORM_VALIDATION_INVALID_EMAIL: "Invalid email",
  FORM_VALIDATION_LENGTH: "Length should be shorter than {length} bytes",

  LOGIN_FORM_EMAIL: "Email",
  LOGIN_FORM_PASSWORD: "Password",
  LOGIN_FORM_LOGIN: "Login",
  LOGIN_FORM_FORGET_PASSWORD: "Forget password?",
  LOGIN_FORM_CREATE_ACCOUNT: "Create account",
  LOGIN_NO_ACCOUNT_YET: "Don`t have an account yet?",
  LOGIN_SIGNUP: "Sign up",
  LOGIN_FAILED_SNACKBAR:
    "Login failed, please check your account & password and try again",
  LOGIN_REDIRECT_DASHBOARD_BUTTON: "Enter system",

  LANGUAGE_SELECTOR_LABEL: "Language",

  TEAM_SELECTOR_PROMPT_OPTION: "Choose team",

  PAGE_NOT_FOUND_TEXT: "Ooops, looks like this page doesn't exist :(",
  PAGE_NOT_FOUND_GO_BACK: "Go back",

  REGISTER_TITLE: "Register new user",
  REGISTER_FORM_EMAIL: "Email",
  REGISTER_FORM_PASSWORD: "Password",
  REGISTER_FORM_REPEAT_PASSWORD: "Repeat password",
  REGISTER_FORM_NAME: "Name",
  REGISTER_FORM_GENDER: "Gender",
  REGISTER_FORM_ADDRESS: "Address",
  REGISTER_FORM_DESCRIPTION: "Description",
  REGISTER_FORM_INVITE_CODE: "Invite code",
  REGISTER_FORM_WEIGHT: "Weight",
  REGISTER_FORM_REGISTER: "Submit",
  REGISTER_PASSWORD_NOT_MATCH: "Passwords do not match",
  REGISTER_FORM_INVITE_CODE_DESC:
    "Only invited user can register for now, please contact smilingky@gmail.com for the invite code.",
  REGISTER_INVALID_INVITE_CODE:
    "Invalid invite code, please contact smilingky@gmail.com",
  REGISTER_EMAIL_REGISTERED:
    "Email has been registered, please change to other email.",
  REGISTER_SUCC: "Register success, please login ",

  FORGET_PASSWORD_TITLE: "We will send reset password email to your account",
  FORGET_PASSWORD_SUBMIT: "Send",

  RESET_PASSWORD_TITLE: "Reset your password",
  RESET_FORM_PASSWORD: "New password",
  RESET_FORM_REPEAT_PASSWORD: "Repeat new password",
  RESET_FORM_SUBMIT: "Reset",

  GENDER_SELECT_MALE: "Male",
  GENDER_SELECT_FEMALE: "Female",

  NO_DATA: "No data",

  SIDEBAR_OVERVIEW: "Overview",
  SIDEBAR_CALENDAR: "Calendar",
  SIDEBAR_TEAMS: "Teams",
  SIDEBAR_EVENTS: "Events",
  SIDEBAR_VIDEO_ANALYZE: "Video Analyze",
  SIDEBAR_VIDEO_MANAGE: "Video manage",
  SIDEBAR_MANAGE: "Manage Section",
  SIDEBAR_MANAGE_CREATE_MATCH: "Create Match",
  SIDEBAR_MANAGE_BATCH_REG_PLAYER: "Register Player",
  SIDEBAR_MANAGE_BATCH_REG_TEAM: "Register Team",
  SIDEBAR_MANAGE_UPDATE_APP: "Update APP",
  SIDEBAR_ANIMATION: "Animation Demo",

  TOP_BAR_OPTION_PROFILE: "Profile",
  TOP_BAR_OPTION_LOGOUT: "Logout",

  EVENTS_VIEW_TITLE: "Events",
  EVENTS_VIEW_ONGOING: "Ongoing events",
  EVENTS_VIEW_FINISHED: "Finished events",
  EVENTS_VIEW_NOT_STARTED: "Not started events",
  EVENTS_VIEW_TEAMS: "Teams",
  EVENTS_VIEW_CALENDAR: "Calendar",

  MEDIA_UPLOAD: "Upload",
  MEDIA_CANCEL: "Cancel",
  MEDIA_DRAG_FILE: "Drag file here",
  MEDIA_UPLOAD_SUCCESS: "File uploaded success",
  MEDIA_LABEL_REMARK: "Remarks",
  MEDIA_SUBMIT: "Submit",
  MEDIA_UPDATE_REMARK_SUCCESS: "Remark updated success",
  MEDIA_MANAGE_MEDIA_LIBRARY: "Media library",
  MEDIA_QUERY_FAILED: "Media list query failed",
  MEDIA_CREATE_AT: "Created at",
  MEDIA_UPDATE_AT: "Updated at",
  MEDIA_REMARK_MODIFY: "Modify Remark",
  MEDIA_COPY_URL: "Copy URL",
  MEDIA_NOTIFICATION_URL_COPIED: "URL copied",

  TEAMS_MANAGE_TITLE: "Teams Management",
  TEAMS_MANAGE_LIST: "Teams list",
  TEAMS_MANAGE_EDIT: "Edit",
  TEAMS_MANAGE_DELETE: "Delete",
  TEAMS_MANAGE_SET_DEFAULT: "Set defualt",
  TEAMS_MANAGE_NO_TEAMS:
    "You are not in any teams yet, please create or join one",
  TEAM_PLAYER_NUM: "{num} players",
  TEAM_MANAGE_ADD: "Create team",
  TEAM_MANAGE_SEARCH: "Search team",
  TEAM_MANAGE_DELETE_PLAYER: "Remove player",
  TEAM_EDIT_NAME: "Team name",
  TEAM_EDIT_LOCATION: "Location",
  TEAM_EDIT_PLAYERS: "Players",
  TEAM_EDIT_ADD_PLAYER: "Add player",
  TEAM_EDIT_PLAYERS_TIPS:
    "put players account(email) here with semicolon(;) as divider, e.g player1@gmail.com;player2@gmail.com)",
  TEAM_EDIT_DESCRIPTION: "Description",
  TEAM_SUBMIT: "Submit",
  TEAM_UPDATE: "Update",
  TEAM_UPDATE_SUCCESS: "Update team success",
  TEAM_UPDATE_FAILED: "Update team failed",
  TEAM_CREATE_FAILED: "Create team failed, please try it again later",
  TEAM_CREATE_SUCCESS: "Create team success",
  TEAM_CREATE_SUCCESS_ACCOUNT_INVITE_FAILED:
    "Team created, but these accounts are not registered in Ballog, please invite them to register manually",
  TEAM_EDIT_BUTTON_ADD_PLAYER: "Add",
  TEAM_EDIT_BUTTON_ADD_PLAYER_CANCEL: "Cancel",
  TEAM_ADD_PLAYER_ERROR:
    "Add player failed, please check emails inputed, make sure semicolon(;) is the divider",
  TEAM_ADD_PLAYER_SUCCESS: "Add player success",
  TEAM_REMOVE_PLAYER_ERROR: "Remove player failed",
  TEAM_REMOVE_PLAYER_IS_OWNER: "Can not remove team owner player",
  TEAM_REMOVE_PLAYER_SUCCESS: "Remove player success",
  PLAYER_NOT_ASSIGN_NUMBER: "No number assigned",

  CALENDAR_CREATE_MATCH: "Create match",

  HOME_TEAM_DATA: "Home team data",
  AWAY_TEAM_DATA: "Away team data",

  MATCH_DASHBOARD_NONBALL_STATS_COMPARE: "Non-ball statistics",
  MATCH_DASHBOARD_NONBALL_STATS_COMPARE_DESC: "(Movement ability)",
  MATCH_DASHBOARD_WITHBALL_STATS_COMPARE: "With-ball statistics",
  MATCH_DASHBOARD_WITHBALL_STATS_COMPARE_DESC: "(With-ball skills)",
  MATCH_DASHBOARD_MATCH_STATS: "Match statistics",
  MATCH_DASHBOARD_STATS_WITHBALL_MANUAL_INPUT: "With-ball data input",
  MATCH_DASHBOARD_STATS_SELECT_SELECT_PLAYERS: "Select players",
  MATCH_DASHBOARD_STATS_SELECT_SELECT_ACTIONS: "Select actions",
  MATCH_DASHBOARD_STATS_SELECT_SELECT_RESULTS: "Select results",
  MATCH_DASHBOARD_STATS_SELECT_SELECT_POSSESSION_STATUS: "possesion status",

  STATS_LABEL_TOUCH_BALL: "Touch Ball Area",
  STATS_LABEL_SAVE: "Saving",
  STATS_LABEL_CLEAR: "Clear",
  STATS_LABEL_PASS: "Pass",
  STATS_LABEL_TACKLE: "Tackle",
  STATS_LABEL_SHOOT: "Shoot",
  STATS_LABEL_DRIBBLE: "Dribble",
  STATS_LABEL_INTERCEPTION: "Interception",
  STATS_LABEL_CROSS: "Cross",
  STATS_LABEL_FOUL: "Foul",
  STATS_LABEL_THROUGH: "Through",
  STATS_LABEL_BLOCK: "Block",
  STATS_LABEL_ASSIST: "Assist",
  STATS_LABEL_OFFSIDE: "Offside",
  STATS_LABEL_OWNGOAL: "Owngoal",
  STATS_LABEL_FREEKICK: "Freekick",
  STATS_LABEL_CORNER: "Corner",
  STATS_LABEL_PENALTY: "Penalty",
  STATS_LABEL_YELLOW: "Yellow",
  STATS_LABEL_RED: "Red",
  STATS_LABEL_DISCIPLINE: "Discipline",
  STATS_LABEL_PASSER: "Passer",
  STATS_LABEL_RECEIVER: "Receiver",
  STATS_LABEL_RECEIVE: "Receive",
  STATS_LABEL_NUMBER: "Total",
  STATS_LABEL_ACTIVE_VALUE: "Active Value",
  STATS_LABEL_ACTIVE_EVENT_DISTANCE: "Active Event Total Distance",
  STATS_LABEL_EFFECTIVE_EVENT_DISTANCE: "Effective Event Distance",
  STATS_LABEL_ACTIVE_EVENT_AMOUNT: "Event Amount",
  STATS_LABEL_EFFECTIVE_ACTIVE_EVENT_AMOUNT: "Effective Event Amount",
  STATS_LABEL_ACTIVE_EVENT_DISTANCE_DESC:
    "The sum of the positional differences of events indicates the player's coverage on the field, with a larger value representing a greater coverage distance.",
  STATS_LABEL_EFFECTIVE_EVENT_DISTANCE_DESC:
    "It is a subset of the Active Event Total Distance concept, where the rule is that if the player is the initiator of the event, regardless of the event's success, it is included in the calculation. However, if the player is the recipient of the event, only successful events are counted.",
  STATS_LABEL_ACTIVE_EVENT_AMOUNT_DESC:
    "All events related to the player, e.g. passing, shooting, dribbling etc, including both the initiator and the recipient of the events.",
  STATS_LABEL_EFFECTIVE_ACTIVE_EVENT_AMOUNT_DESC:
    "It is a subset of the Active Event concept, where the rule is that if the player is the initiator of the event, regardless of the event's success, it is included in the calculation. However, if the player is the recipient of the event, only successful events are counted.",

  STATS_LABEL_SPEED: "Speed",
  STATS_LABEL_DISTANCE: "Distance",
  STATS_LABEL_WALK: "Walk",
  STATS_LABEL_JOGGING: "Jogging",
  STATS_LABEL_RUN: "Run",
  STATS_LABEL_SPRINT: "Sprint",
  STATS_LABEL_ATTACK: "Attack",
  STATS_LABEL_DEFENCE: "Defence",
  STATS_LABEL_CALORIE: "Calories",

  STATS_SUCC: "Succ",
  STATS_FAIL: "Fail",
  STATS_POS_SELF: "Own half",
  STATS_POS_OTHER: "Opponent half",
  STATS_POSSESSION: "Possession",
  STATS_POSSESSION_WIN: "Win possession",
  STATS_POSSESSION_LOSE: "Lose possession",

  SCHEDULE_LABEL: "Schedule",
  SCHEDULE_CALENDAR_WHOLE_DAY: "Whole day",
  SCHEDULE_CALENDAR_LAST_MONTH: "Last month",
  SCHEDULE_CALENDAR_NEXT_MONTH: "Next month",
  SCHEDULE_CALENDAR_TODAY: "Today",
  SCHEDULE_CALENDAR_MONTH: "Month",
  SCHEDULE_CALENDAR_WEEK: "Week",
  SCHEDULE_CALENDAR_DAY: "Day",
  SCHEDULE_CALENDAR_AGENDA: "Agenda",
  SCHEDULE_CALENDAR_MORE: "More",

  MATCH_TEAM_TITLE: "Data details",
  STATS_TEAM_TITLE: "Data details in year {year}",
  MATCH_TEAM_TAB_TEAM_OVERVIEW: "Overview",
  MATCH_TEAM_TAB_TEAM_STATS_BOARD: "Statistics board",
  MATCH_TEAM_NO_DATA: "Have not inputed any data for this team",

  MATCH_TEAM_OVERVIEW_PASS_TOTAL: "Total pass",
  MATCH_TEAM_OVERVIEW_FORWARD_PASS_TOTAL: "Forward pass",
  MATCH_TEAM_OVERVIEW_BACKWARD_PASS_TOTAL: "Backward pass",
  MATCH_TEAM_OVERVIEW_CROSS_PASS_TOTAL: "Cross pass",
  MATCH_TEAM_OVERVIEW_SHORT_PASS_TOTAL: "Short pass",
  MATCH_TEAM_OVERVIEW_LONG_PASS_TOTAL: "Long pass",
  MATCH_TEAM_OVERVIEW_THROW_IN_PASS_TOTAL: "Throw in",
  MATCH_TEAM_OVERVIEW_OWN_HALF_PASS_TOTAL: "Pass in own half",
  MATCH_TEAM_OVERVIEW_OTHER_HALF_PASS_TOTAL: "Pass in other half",
  MATCH_TEAM_OVERVIEW_PASS_SUCC: "Successful pass",
  MATCH_TEAM_OVERVIEW_PASS_SUCC_RATE: "Success rate",
  MATCH_TEAM_OVERVIEW_TABLE_DESC: "From \\\\ To",
  MATCH_TEAM_OVERVIEW_SHOOT_TOTAL: "Total",
  MATCH_TEAM_OVERVIEW_SHOOT_IN_PENALTY_TOTAL: "Shoot inside penalty",
  MATCH_TEAM_OVERVIEW_SHOOT_OUT_PENALTY_TOTAL: "Shoot outside penalty",
  MATCH_TEAM_OVERVIEW_SHOOT_IN_TARGET: "In target",
  MATCH_TEAM_OVERVIEW_SHOOT_GOAL: "Goal",
  MATCH_TEAM_OVERVIEW_SHOOT_CHART_TITLE: "Shoot",
  MATCH_TEAM_OVERVIEW_LAST_PASS_CHART_TITLE: "Last pass",
  MATCH_TEAM_OVERVIEW_ASSIST_TOTAL: "Total",
  MATCH_TEAM_OVERVIEW_DRIBBLE_ATTEMPT_TOTAL: "Attempt dribble",
  MATCH_TEAM_OVERVIEW_DRIBBLE_SUCC: "Succ dribble",

  MATCH_TEAM_PERSONAL_VIEW_PASS_TO_CHART_TITLE: "Who I pass to",
  MATCH_TEAM_PERSONAL_VIEW_PASS_FROM_CHART_TITLE: "Who pass to me",
  MATCH_TEAM_PERSONAL_VIEW_PASS_CHART_TOTAL: "Successful pass",
  MATCH_TEAM_PERSONAL_VIEW_SHOOT_LEFT: "Left foot",
  MATCH_TEAM_PERSONAL_VIEW_SHOOT_RIGHT: "Right foot",
  MATCH_TEAM_PERSONAL_VIEW_SHOOT_HEADER: "Header",
  MATCH_TEAM_PERSONAL_VIEW_SHOOT_CHART_TITLE: "Who made the last pass to me",
  MATCH_TEAM_PERSONAL_VIEW_SHOOT_CHART_BY_ME: "Myself",
  MATCH_TEAM_PERSONAL_VIEW_SHOOT_SKETCH_MAP_TITLE: "Shooting line diagram",

  BC_TEAMS_MANAGE_HOME: "Teams Management",
  BC_TEAMS_MANAGE_CREATE: "Create team",
  BC_TEAMS_MANAGE_EDIT: "Edit team",
  BC_TEAMS_MANAGE_VIEW: "Team Info",

  FORM_GENERAL_CANCEL: "Cancel",

  CREATE_MATCH_FIELD_LEAGUE: "League",
  CREATE_MATCH_FIELD_LOCATION: "Location",
  CREATE_MATCH_FIELD_TIME: "Match time",
  CREATE_MATCH_FIELD_HOME_TEAM: "Home team",
  CREATE_MATCH_FIELD_AWAY_TEAM: "Away team",
  CREATE_MATCH_FIELD_DESCRIPTION: "Description",
  CREATE_MATCH_FIELD_PLAYER_NUM: "Player number",
  CREATE_MATCH_VALIDATION_AT_LEAST_ONE_TEAM_VALID:
    "Please input at least one valid team",
  CREATE_MATCH_FAILED: "Create match failed, please try it again later",
  CREATE_MATCH_SUCCESS: "Create match success",

  WITHBALL_INPUT_URL_PLACEHOLDER: "Video URL",
  WITHBALL_INPUT_VIDEO_LOAD_BUTTON: "load",
  WITHBALL_DATETIME_SYNC_BUTTON: "sync",
  WITHBALL_VIDEO_TIME: "Video time",
  WITHBALL_MATCH_TIME: "Match time",

  STAT_ACTION_PASS_SHORT: "PASS",
  STAT_ACTION_THROUGH_SHORT: "THRO",
  STAT_ACTION_DRIBBLE_SHORT: "DRIB",
  STAT_ACTION_SHOOT_SHORT: "SHOT",
  STAT_ACTION_OFFSIDE_SHORT: "OFSD",
  STAT_ACTION_TACKLE_SHORT: "TACK",
  STAT_ACTION_INTERCEPTION_SHORT: "INCE",
  STAT_ACTION_BLOCK_SHORT: "BLOK",
  STAT_ACTION_CLEARANCE_SHORT: "CLEA",
  STAT_ACTION_SAVING_SHORT: "SAVE",
  STAT_ACTION_OWNGOAL_SHORT: "OWNG",
  STAT_ACTION_FREE_KICK_SHORT: "FREE",
  STAT_ACTION_CORNER_KICK_SHORT: "CORN",
  STAT_ACTION_PENALTY_KICK_SHORT: "PENA",
  STAT_ACTION_FOUL_SHORT: "FOUL",
  STAT_ACTION_YELLOW_SHORT: "YELL",
  STAT_ACTION_RED_SHORT: "RED",

  STAT_ACTION_SWITCH: "switch",

  STAT_ACTION_PASS: "Pass",
  STAT_ACTION_THROUGH: "Through",
  STAT_ACTION_DRIBBLE: "Dribble",
  STAT_ACTION_SHOOT: "Shoot",
  STAT_ACTION_OFFSIDE: "Offside",
  STAT_ACTION_TACKLE: "Tackle",
  STAT_ACTION_INTERCEPTION: "Interception",
  STAT_ACTION_BLOCK: "Block",
  STAT_ACTION_CLEARANCE: "Clearance",
  STAT_ACTION_SAVING: "Saving",
  STAT_ACTION_OWNGOAL: "Own Goal",
  STAT_ACTION_FREE_KICK: "Free Kick",
  STAT_ACTION_CORNER_KICK: "Corner Kick",
  STAT_ACTION_PENALTY_KICK: "Penalty Kick",
  STAT_ACTION_FOUL: "Foul",
  STAT_ACTION_YELLOW: "Yellow Card",
  STAT_ACTION_RED: "Red Card",

  STAT_FORM_LABEL_TEAM: "Team",
  STAT_FORM_LABEL_HOME: "Home",
  STAT_FORM_LABEL_AWAY: "Away",
  STAT_FORM_LABEL_ACTION_TYPE: "Action",
  STAT_FORM_LABEL_PLAYER: "Player",
  STAT_FORM_LABEL_METHOD: "Type",
  STAT_FORM_LABEL_BODY_PART: "Body Part",
  STAT_FORM_LABEL_THREAT: "Threat",
  STAT_FORM_LABEL_RESULT: "Result",
  STAT_FORM_LABEL_POSSESSION: "Possession",
  STAT_FORM_LABEL_HOME_TEAM_SIDE: "Home Team Side",
  STAT_FORM_LABEL_IN_TARGET: "In Target",
  STAT_FORM_LABEL_SUBMIT: "Submit",
  STAT_FORM_SUBMIT_MATCH_RESULT: "Submit Match Result",
  STAT_SCORES_FROM_INPUT_LIST: "Detect {scores} goals from input",
  STAT_HOME_SCORES: "Home Team Scores",
  STAT_AWAY_SCORES: "Away Teaam Scores",

  STAT_PASS_SHORT: "Short Pass",
  STAT_PASS_LONG: "Long Pass",
  STAT_PASS_THROW_IN: "Throw In",

  STAT_SHOOT_IN_PENALTY: "Inside Penalty",
  STAT_SHOOT_OUT_PENALTY: "Outside Penalty",

  STAT_TACKLE_NORMAL: "Normal",
  STAT_TACKLE_SLIDING: "Sliding",

  STAT_PASS_FOOT: "Foot",
  STAT_PASS_HEAD: "Head",

  STAT_SHOOT_RIGHT_FOOT: "Right Foot",
  STAT_SHOOT_LEFT_FOOT: "Left Foot",
  STAT_SHOOT_HEAD: "Head",

  STAT_RESULT_SUCCESS: "Success",
  STAT_RESULT_FAILED: "Failed",

  STAT_POSSESSION_WIN: "Win",
  STAT_POSSESSION_KEEP: "Keep",
  STAT_POSSESSION_LOSE: "Lose",

  STAT_HOME_TEAM_LEFT: "Left",
  STAT_HOME_TEAM_RIGHT: "Right",

  STAT_FREEKICK_DIRECT: "Direct",
  STAT_FREEKICK_INDIRECT: "Indirect",

  STAT_NOTIFICATION_WITHBALL_POST_SUCCESS: "Data uploaded",
  STAT_NOTIFICATION_WITHBALL_POST_FAILED: "Upload failed",
  STAT_NOTIFICATION_WITHBALL_DELETE_FAILED: "Delete failed",

  STAT_TABLE_HEADER_TEAM: "Team",
  STAT_TABLE_HEADER_ACTION: "Action",
  STAT_TABLE_HEADER_FROM: "From",
  STAT_TABLE_HEADER_TO: "To/Assist",
  STAT_TABLE_HEADER_POSSESSION: "Possession",
  STAT_TABLE_HEADER_RESULT: "Result",
  STAT_TABLE_HEADER_OPERATION: "Operation",
  STAT_TABLE_HEADER_POSITOIN: "Position",
  STAT_TABLE_HEADER_TIMESTAMP: "Timestamp(s)",
  STAT_TABLE_HEADER_PLAY: "Play",

  NONE_TEAM_SELECTED: "None team selected",
  TEAM_NOT_REGISTERED: "Team not registered",
  NONE_PLAYER_SELECTED: "None player selected",

  MATCH_STATS_TITLE: "Match Statistics",
  MATCH_STATS_TECHNICAL_STATISTICS: "Technical Statistics",
  MATCH_STATS_DATA_INPUT: "Input Data",
  MATCH_STATS_HOME_TEAM_DATA: "Home Team Data",
  MATCH_STATS_AWAY_TEAM_DATA: "Away Team Data",
  MATCH_STATS_TEAM_OVERALL: "Team Overall",
  MATCH_STATS_UNKNOWN_PLAYER: "Unknown Player",
  MATCH_RESULT_SUBMIT_SUCC: "Match scores submitted",

  EDIT_STATS_DIALOG_TITLE: "Edit Stats Data",
  EDIT_STATS_DIALOG_CANCEL: "Cancel",
  EDIT_STATS_DIALOG_UPDATE: "Update",

  LANDING_DESC_TITLE: "Your online data analyst",
  LANDING_DESC_SUB_TITLE:
    "Offer online football data analysis service to every team, helping football more professional, more fun",
  LANDING_VALUE_EASY_TO_USE_TITLE: "Easy to use",
  LANDING_VALUE_EASY_TO_USE_DESC:
    "You can sit in front of the computer after the game, drink coffee, and watch the video to easily complete the technical data entry, or you can give the video recording to our professionals to help you entering into system.",
  LANDING_VALUE_COMPREHENSIVE_DATA_TITLE: "Comprehensive data collection",
  LANDING_VALUE_COMPREHENSIVE_DATA_DESC:
    "Offer a affordable solution to collect player movement / position data automatic with wearable devices.",
  LANDING_HELP_TILE: "Contact us for any help!",
  LANDING_HELP_DESC:
    "This system was originally used for my team daily traing and match, now open for use by the coaches of grassroots teams. If you need it, contact me to create a test account.",

  SEND_RESET_PASSWORD_EMAIL_SUCCESS: "Email sent, please check.",
  SEND_RESET_PASSWORD_EMAIL_FAILED:
    "Can not send email to your account, please try again!",
  SEND_RESET_PASSWORD_NOT_MATCH: "Passwords does not match !",
  RESET_PASSWORD_SUCCESS: "Reset success, please login with new password.",
  RESET_PASSWORD_FAILED: "Invalid token, please request reset email again!",

  ROLE_ADMIN: "System Admin",
  ROLE_TEAM_MANAGER: "Team Manager",
  ROLE_MATCH_ADMIN: "Match Recorder",
  ROLE_NORMAL: "Player",

  PLAYER_EDIT_NUMBER: "Number",
  PLAYER_EDIT_ROLE: "Role",
  PLAYER_EDIT_SAVE: "Save",
  PLAYER_EDIT_REMOVE: "Remove",
  PLAYER_EDIT_SUCCESS: "Update success",
  PLAYER_EDIT_NUMBER_FAILED: "Update number failed",
  PLAYER_EDIT_ROLES_FAILED: "Update roles failed",

  TEAM_DASHBOARD: "Team Dashboard",
  TEAM_DASHBOARD_CURRENT_TEAM: "Current Team",
  TEAM_DASHBOARD_NAV_MANAGE: "Manage Teams",
  TEAM_DASHBOARD_NAV_EVENT_ON_VIDEO: "Events on Video",
  TEAM_DASHBOARD_NAV_EVENT_CHART: "Chart",
  TEAM_DASHBOARD_PLAYERS: "{ playerNum } players",
  TEAM_DASHBOARD_ANNUAL_DATA: "Annual Data View",
  TEAM_DASHBOARD_ANNUAL_MATCH_1:
    "{ matchNum } matches happened within this year",
  TEAM_DASHBOARD_ANNUAL_MATCH_2: "Won { win }, lose { lose }, draw { draw }",
  TEAM_DASHBOARD_ANNUAL_MATCH_3:
    "Total goals { totalScores } ({ averageScores } per match). Total conceded { totalLoseScores } ({ averageLoseScores } per match)",
  TEAM_DASHBOARD_ANNUAL_PLAYER_RANKING: "Players Annual Data",
  TEAM_DASHBOARD_ANNUAL_PLAYER_DETAIL_DATA: "Check Details",
  TEAM_DASHBOARD_ANNUAL_PLAYER_SCORE: "Score",
  TEAM_DASHBOARD_ANNUAL_PLAYER_ASSISTANT: "Assistant",
  TEAM_DASHBOARD_ANNUAL_PLAYER_TACKLE: "Tackle",
  TEAM_DASHBOARD_ANNUAL_PLAYER_INTERCEPTION: "Interception",
  TEAM_DASHBOARD_ANNUAL_PLAYER_PASS_TOTAL: "Total Passes",
  TEAM_DASHBOARD_ANNUAL_PLAYER_PASS_RATE: "Pass Success Rate",
  TEAM_DASHBOARD_ANNUAL_PLAYER_DRIBBLE: "Dribble",
  TEAM_DASHBOARD_LEGEND_GOAL_DIFFERENCE: "Goal Difference",
  TEAM_DASHBOARD_EXPORT_VIDEO: "Export Video",
  TEAM_DASHBOARD_VIDEO_SELECT: "Select",
  TEAM_DASHBOARD_PLAY_VIDEO: "Play Video",
};

export default msg;
